import { NuevoMiembroComponent } from './../nuevo-miembro/nuevo-miembro.component';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

interface Matriz {
  nombre: string;
  miembros: string[];
  horario: any;
}

@Component({
  selector: 'app-matriz',
  templateUrl: './matriz.component.html',
  styleUrls: ['./matriz.component.css']
})
export class MatrizComponent implements OnInit {

  objectKeys = Object.keys;

  matriz: Observable<Matriz>;
  horarioCollection: AngularFirestoreCollection<any>;
  horario: Observable<any>;
  id: string;
  miembros: string[];
  user = '';

  constructor(private route: ActivatedRoute, public afs: AngularFirestore, public dialog: MatDialog,
              public router: Router) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.id = params['name'];
      this.matriz = this.afs.collection('matrices').doc<Matriz>(params['name']).valueChanges();
      this.horarioCollection = this.afs.collection('matrices').doc<Matriz>(params['name']).collection('horario');
      this.horario = this.horarioCollection.snapshotChanges().map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, data };
        });
      });
      this.matriz.subscribe(change => {
        this.miembros = change.miembros;
      });
    });
  }

  selectList(nombre, state, dia, position) {
    console.log(nombre, state, dia);
    const user = (state) ? this.user : '';
    this.horarioCollection.doc(dia).update({
      [nombre]: {
        state: state,
        user: user,
        position: position
      }
    });
  }

  agregarMiembro() {
    const dialog = this.dialog.open(NuevoMiembroComponent, {
      width: '60%'
    });
    dialog.afterClosed().subscribe(result => {
      if (result) {
        this.miembros.push(result);
        this.afs.collection('matrices').doc < Matriz > (this.id).update({
          miembros: this.miembros
        });
        this.user = result;
      }
    });
  }

  userChanged(user) {
    this.user = user;
  }

  trackByFn(index, item) {
    return item.id;
  }


}



// WEBPACK FOOTER //
// ./src/app/matriz/matriz.component.ts